class CustomSearchInput {
  constructor() {
    this.init();
  }
  clickEvent = () => {
    const clickBtn = document.querySelectorAll(".quick-search__clear-cancel")
    const closeBtn = document.querySelectorAll(".quick-search__cancel")
    const clearBtn = document.querySelectorAll(".quick-search__clear")
    if(clickBtn){
      clickBtn.forEach(element => {
        element.addEventListener("click",()=>{
          if (window.innerWidth < 769){
            if(clearBtn){
              clearBtn[1].click()
            }
            if(closeBtn){
              closeBtn[1].click()
            }
          }
        })
      });
    }
  }
 
  init() {
    this.clickEvent()
  }
}

new CustomSearchInput();